<template>
  <gg-card class="fill-height">
    <gg-card-text>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Status</strong>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>{{ details.status }}</v-list-item-action>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Date Generated</strong>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>{{ details.date_generated }}</v-list-item-action>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Timeframe</strong>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>{{ details.timeframe_action === timeframeActions.CANCEL_NOW ? 'Cancel Now' : 'Do Not Renew' }}</v-list-item-action>
        </v-list-item>

        <v-list-item v-if="details.can_expedite">
          <v-list-item-content>
            <v-list-item-title>
              <gg-btn
                v-if="details.timeframe_action !== timeframeActions.CANCEL_NOW"
                @click="$emit('cancel-now')"
                small
                tile
                color="primary"
                class="mr-1"
              >
                Cancel Now
              </gg-btn>
              <gg-btn
                @click="$emit('autorenew-now')"
                small
                color="gray-dark"
              >
                I Changed My Mind
              </gg-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-if="details.escalated">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <strong class="red--text text--lighten-1">Request
                  Escalated</strong>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <strong>Offer</strong>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>{{ details.offer_name }}</v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <strong>Summary</strong>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>{{ details.offer_message }}</v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { timeframeActions } from '@/consts/cancellations'

export default {
  name: 'CancellationData',
  props: {
    details: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      timeframeActions,
    }
  }
}
</script>
